import React, { useState, useEffect } from "react";
import { VideoCard } from "../Components/VideoCard";
import { Button, Box, Typography, Grid, Stack } from "@mui/material";
import { Search } from "@mui/icons-material";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import "./LandingPage.css";
import axios from "axios";
import { GenreChips, GenreChips2, GenreChips3 } from "../Components/GenreChips";
import { url, allVideosParam } from "../config";
import { CalculateMonth } from "../Components/calculateMonth";
import { FormDialog } from "../Components/UploadModal";

const initialState = {
  videoLink: "",
  title: "",
  genre: "",
  contentRating: "",
  releaseDate: null,
  previewImage: "",
};

export const LandingPage = () => {
  const [videoData, setVideoData] = useState();
  const [selectedAge, setSelectedAge] = useState(null);
  const [timerId, setTimerId] = useState();
  const [genreArr, setGenreArr] = useState([]);
  const [genreNameArr, setGenreNameArr] = useState(["All Genre"]);
  const [title, setTitle] = useState("");
  const [selectedSort, setSelectedSort] = useState("viewCount");
  const [open, setOpen] = useState(false);
  const [postVideoData, setPostVideoData] = useState(initialState);

  const allGenres = ["All Genre", "Education", "Sports", "Lifestyle"];
  const ageGroup = ["Any age group", "7+", "12+", "16+", "18+"];
  const fetchData = async (url) => {
    try {
      const response = await axios.get(url);
      setVideoData(response.data.videos);
    } catch (error) {
      console.log(error.response);
    }
  };

  const onClickAge = async (value) => {
    if (selectedAge === value) {
      setSelectedAge(null);
    } else {
      setSelectedAge(value);
    }
  };

  const onClickGenre = async (value) => {
    if (value === "All Genre") {
      setGenreArr([]);
      setGenreNameArr(["All Genre"]);
      return await fetchData(url + allVideosParam);
    }
    if (genreArr.includes(value) && genreNameArr.includes(value)) {
      setGenreArr(genreArr.filter((g) => g !== value));
      setGenreNameArr(
        genreNameArr.filter((g) => g !== value && g !== "All Genre")
      );
    } else {
      setGenreArr([...genreArr, value]);
      setGenreNameArr([
        ...genreNameArr.filter((value) => value !== "All Genre"),
        value,
      ]);
    }
  };

  const handleClick = () => {
    setOpen(!open);
  };
  const handleSubmit = async () => {
    const options = { day: "numeric", month: "short", year: "numeric" };
    const date = {
      ...postVideoData,
      releaseDate: new Date(postVideoData.releaseDate).toLocaleDateString(
        "en-IN",
        options
      ),
    };
    await axios.post(url + allVideosParam, date);
    setPostVideoData(initialState);
    setOpen(!open);
  };
  const handleCancel = () => {
    setPostVideoData(initialState);
    handleClick();
  };
  const setPostData = (name, value) => {
    setPostVideoData({
      ...postVideoData,
      [name]: value,
    });
  };

  const performSearch = (text) => {
    setTitle(text);
  };

  const debounceSearch = (event, debounceTimeout = 500) => {
    if (timerId) {
      clearTimeout(timerId);
    }
    const debounceTimeoutId = setTimeout(
      () => performSearch(event),
      debounceTimeout
    );
    setTimerId(debounceTimeoutId);
  };

  useEffect(() => {
    fetchData(url + allVideosParam);
  }, []);

  useEffect(() => {
    let params = `${allVideosParam}?`;

    if (genreArr.length) {
      params = params + "genres=" + genreArr.join(",");
    }

    if (selectedAge && selectedAge !== "Any age group") {
      if (genreArr.length) {
        params = params + "&contentRating=" + encodeURIComponent(selectedAge);
      } else {
        params = params + "contentRating=" + encodeURIComponent(selectedAge);
      }
    }

    if (title) {
      if (selectedAge || genreArr.length) {
        params = params + "&title=" + encodeURIComponent(title);
      } else {
        params = params + "title=" + encodeURIComponent(title);
      }
    }

    if (selectedSort) {
      if (title || selectedAge || genreArr.length) {
        params = params + "&sortBy=" + selectedSort;
      } else {
        params = params + "sortBy=" + selectedSort;
      }
    }

    fetchData(url + params);
  }, [genreArr, selectedAge, title, selectedSort]);

  return (
    <div>
      {open && (
        <FormDialog
          isOpen={open}
          postVideoData={postVideoData}
          handleSubmit={handleSubmit}
          handleChange={setPostData}
          handleClose={() => handleClick()}
          handleCancel={handleCancel}
        />
      )}
      <Box
        display="flex"
        justifyContent="space-between"
        bgcolor="#202020"
        padding="13px"
      >
        <Typography color="#FFFFFF" fontSize="24px">
          <span className="xFlix">X</span>Flix
        </Typography>
        <Box className="search-box">
          <input
            size="small"
            placeholder="Search"
            name="search"
            className="inputField"
            onChange={(e) => debounceSearch(e.target.value)}
          />
          <Box className="search-button">
            <Search color="#606060" />
          </Box>
        </Box>

        <Button
          variant="contained"
          startIcon={<FileUploadIcon />}
          sx={{ width: "115px", height: "30px" }}
          onClick={() => handleClick()}
        >
          Upload
        </Button>
      </Box>
      <Grid container bgcolor="#202020">
        <Grid
          item
          xs={12}
          ls={12}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Stack spacing={2} direction="row" justifyContent="center">
            {allGenres.map((genre) => (
              <GenreChips
                keyValue={genre}
                name={genre}
                genreNameArr={genreNameArr}
                onClickGenre={() => onClickGenre(genre)}
              />
            ))}
          </Stack>
          <Grid item  marginLeft={6}>
            <GenreChips3 handleChange={(value) => setSelectedSort(value)} />
          </Grid>
        </Grid>
      </Grid>
      <Box bgcolor="#202020" paddingY="24px">
        <Stack spacing={3} direction="row" justifyContent="center">
          {ageGroup.map((age) => (
            <GenreChips2
              keyValue={age}
              active={selectedAge === age}
              onClickAge={() => onClickAge(age)}
              name={age}
            />
          ))}
        </Stack>
      </Box>
      <Box bgcolor="#181818" height="120%">
        <Grid container spacing={2} sx={{ px: 10 }} marginTop="0">
          {videoData &&
            videoData.map((card) => (
              <Grid item xs={6} md={3}>
                <VideoCard
                  keyValue={card._id}
                  image={card.previewImage}
                  videoTitle={card.title}
                  videoId={card._id}
                  time={CalculateMonth(card.releaseDate)}
                />
              </Grid>
            ))}
        </Grid>
      </Box>
    </div>
  );
};
